export enum ROUTES {
  List = '/',
  RegisterNew = '/new',
  DetailedView = '/manage'
}
